import ApiService from "./api.service";

const ProfileService = {
  async showPointsByCustomerNumber(id) {
    try {
      return await ApiService.get(`profiles/${id}/points-by-customer-number`);
    } catch (e) {
      console.error(e);
    }
  },
  async showKickbackInfo(groupId) {
    try {
      return await ApiService.get(`display-kickback-info?groupId=${groupId}`);
    } catch (e) {
      console.error(e);
    }
  },
  async storeStaffToDealer(data) {
    try {
      return await ApiService.post("sync-staff", data);
    } catch (error) {
      return error.response;
    }
  },
  /**
   * Another user's profile only (admin / wholesaler). Never use for "my profile".
   * @param {string} userOrProfileHashId - user.id or profile.id hashid, never plainId
   */
  async userProfileData(userOrProfileHashId) {
    if (!userOrProfileHashId || userOrProfileHashId === "form-data") {
      console.error("userProfileData: invalid hashid", userOrProfileHashId);
      return null;
    }
    try {
      return await ApiService.get(`profiles/${userOrProfileHashId}`);
    } catch (e) {
      return e.response;
    }
  },
  /**
   * Own profile form — single load for "Mój profil". Do not call GET /profiles/{id} after this.
   * @param {{ includeWholesalers?: boolean }} [options]
   * @returns {Promise<{ user: object, parent_attributes: unknown, wholesalers?: object }|null>}
   */
  async fetchMyProfileForm(options = {}) {
    const response = await this.getProfileFormData(options);
    if (response?.status === 200 && response?.data?.data) {
      return response.data.data;
    }
    return null;
  },
  async getProfileFormData(options = {}) {
    try {
      const { includeWholesalers = true } = options;
      const params = new URLSearchParams();
      params.set("include_wholesalers", String(includeWholesalers));
      return await ApiService.get(`profiles/form-data?${params.toString()}`);
    } catch (e) {
      return e.response;
    }
  },
  /**
   * Save own profile (basic fields). profile.user_id must be user hashid (user.id).
   * @param {object} profileFields
   * @param {string} userHashId
   */
  async saveMyProfile(profileFields, userHashId) {
    try {
      return await ApiService.put(`profiles/initial-data/update`, {
        profile: {
          ...profileFields,
          user_id: userHashId,
        },
      });
    } catch (e) {
      return e.response;
    }
  },
  async storeProfilePercentage(data) {
    try {
      return await ApiService.post("profiles/percentage", data);
    } catch (e) {
      console.log(e);
    }
  },
  async profilePercentage(userId) {
    try {
      return await ApiService.get(`profiles/${userId}/user`);
    } catch (e) {
      console.log(e);
    }
  },
  async storeFullProfilePoints(userId) {
    try {
      return await ApiService.post(`profiles/full-data-points/${userId}`);
    } catch (e) {
      console.log(e);
    }
  },
  async tyreLimitYearly(year) {
    try {
      return await ApiService.get(`shop-limit/${year}`);
    } catch (e) {
      console.log(e);
    }
  },
  async updateInitialData(data) {
    try {
      return await ApiService.put(`profiles/initial-data/update`, data);
    } catch (e) {
      console.error(e);
    }
  },
  async updateUserLiteIntro(data) {
    try {
      return await ApiService.put(`update/lite-intro/${data.id}`, data);
    } catch (e) {
      return e.response;
    }
  },

  permissions() {
    return ApiService.get(`tenant/permissions`);
  },
  async pointBoard() {
    return ApiService.get(`display-point-board`);
  },

  async setTyreGoal(data) {
    try {
      return await ApiService.put("set-bonus-level", data);
    } catch (e) {
      console.log(e);
    }
  },
};

export { ProfileService };
